import styled from 'styled-components'

export const LinkNulingaCourses = styled.a`
  &:visited,
  &:link {
    color: ${({ theme }) => theme.colors.primary.normal};
  }
`
